<script>
import Alert from '@/components(new)/UI/Alert/Alert.vue'
import ButtonsFinais from '@/components(new)/UI/Buttons/ButtonsFinais/ButtonsFinais.vue'
import InputRadio from '@/components(new)/UI/Forms/InputRadio/InputRadio.vue'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import HeaderVoltar from '@/components(new)/UI/HeaderVoltar/HeaderVoltar.vue'
import RegistrationMap from '@/components(new)/UI/Maps/RegistrationMap/RegistrationMap.vue'
import Steps from '@/components(new)/UI/Steps/Steps.vue'
import TitleWithRow from '@/components(new)/UI/Typography/TitleWithRow/TitleWithRow.vue'
import Endereco from '@/components(new)/UI/Forms/FormulariosProntos/Endereco/Endereco.vue'
import { situacaoImovel, tipoPosse, documentoReformaAgraria, documentoQuilombo } from '@/libs/constants/imovel'
import { mapGetters } from 'vuex'
import { validaTipoCadastro } from '@/utils/utils'

export default {
  components: {
    HeaderVoltar,
    Alert,
    ButtonsFinais,
    Steps,
    TitleWithRow,
    InputRadio,
    InputSelect,
    Label,
    RegistrationMap,
    Endereco
  },
  props: {
    cadastro: {
      type: Object,
      required: true
    },
    tipoCadastro: {
      required: true,
      validator: value => validaTipoCadastro(value)
    }
  },
  data () {
    return {
      nomeAba: 'Imóvel',
      numeroCar: '',
      situacaoImovel,
      tipoPosse,
      documentoQuilombo,
      documentoReformaAgraria,
      camposPorSituacao: {
        PROPRIETARIO: [
          'registroImovel.proprietarioImovel.numeroMatricula'
        ],
        POSSEIRO: [
          'registroImovel.posseiro.tipoPosse',
          'registroImovel.posseiro.detalhePosse'
        ],
        ASSENTADO_REFORMA_AGRARIA: [
          'registroImovel.assentamentoReforma.nomeProjeto',
          'registroImovel.assentamentoReforma.documento',
          'registroImovel.assentamentoReforma.outrosDocumentos',
          'registroImovel.assentamentoReforma.especificacaoDocumento'
        ],
        QUILOMBOLA: [
          'registroImovel.quilombola.nomeQuilombo',
          'registroImovel.quilombola.documento',
          'registroImovel.quilombola.especificacaoDocumento',
          'registroImovel.quilombola.outrosDocumentos'
        ],
        INDIGENA: [
          'registroImovel.indigena.terra',
          'registroImovel.indigena.aldeia',
          'registroImovel.indigena.povo'
        ],
        OUTROS: [
          'registroImovel.especificacaoOutros'
        ]
      }
    }
  },
  async mounted () {
    await this.setDadosImovel()
  },
  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado',
      usuario: 'auth/usuarioLogado'
    }),
    imovel () {
      return this.cadastro.imovel
    },
    enderecoCopiado () {
      switch (this.tipoCadastro) {
        case 'EMPRESA':
          return this.usuarioLogado.pessoa.endereco
        default:
          return this.cadastro.proprietario.pessoa.enderecoCorrespondencia
      }
    }
  },
  methods: {
    handleSituacaoImovel (value) {
      Object.keys(this.camposPorSituacao).forEach(situacao => {
        if (situacao !== value) {
          this.camposPorSituacao[situacao].forEach(caminho => {
            this.setValorPorCaminho(this.cadastro.imovel, caminho, null)
          })
        }
      })
    },
    async setDadosImovel () {
      if (this.imovel?.geoJson?.length) {
        this.$refs.registrationMap.addProperty({geoJsonList: this.imovel.geoJson, numerosCar: this.imovel.numerosRecibosCar})
        this.imovel.numerosRecibosCar.filter(car => !car.geoJson)
          .forEach(car => this.$refs.registrationMap.addCARLayer(car))
      }
    },
    handleNumCar (value) {
      if (!value) {
        this.imovel.numerosRecibosCar.forEach(n => this.$refs.registrationMap.removeCar(n.numero))
        this.imovel.numerosRecibosCar = []
      }
    },
    async addCarNum (carNumber) {
      this.numeroCar = ''
      const carUnformated = carNumber.replace(/\./g, '')
      await this.$refs.registrationMap.addCARLayer(carNumber)
      if (!this.imovel.numerosRecibosCar.find(item => item.numero === carUnformated)) {
        this.imovel.numerosRecibosCar.push({numero: carUnformated, geoJson: ''})
      }
    },
    removeCarNum (carNumber) {
      this.imovel.numerosRecibosCar = this.imovel.numerosRecibosCar.filter((item) => item.numero !== carNumber)
      this.$refs.registrationMap.removeCar(carNumber)
    },
    handleCarInfo (carInfo) {
      this.imovel.geoJson = carInfo.layers
      if (carInfo.current.length) {
        const currentSet = new Set(this.imovel.numerosRecibosCar)

        const newItems = carInfo.current.filter(item => !currentSet.has(item))

        currentSet.forEach(c => {
          if (!c.geoJson) newItems.push(c)
        })

        this.imovel.numerosRecibosCar = [...newItems]
        return
      }
      this.imovel.numerosRecibosCar = this.imovel.numerosRecibosCar.filter((item) => !carInfo.prev.includes(item))
    },
    setLayers (layers) {
      this.imovel.geoJson = layers
      this.imovel.area = layers[0].area
    },
    // apaga os valores dos formulários após selecionar outro tipo de imóvel
    setValorPorCaminho (obj, caminho, valor) {
      const partes = caminho.split('.')
      const ultima = partes.pop()
      const ref = partes.reduce((acc, chave) => acc?.[chave], obj)
      if (ref && ultima in ref) {
        ref[ultima] = valor
      }
    }
  }
}
</script>

<template>
  <div>
    <TitleWithRow title="Dados do imóvel" />
    <el-row>
      <validation-provider rules="required" v-slot="{ errors }" mode="lazy" :name="nomeAba + '/Nome do imóvel'">
        <el-col :span="12">
          <Label label="Nome do imóvel:" :obrigatorio="true" />
          <el-input name="Nome do imóvel" v-model="imovel.nome" :class="{'input erro' : errors.length}" />
          <span class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>
    </el-row>
    <el-row>
      <InputRadio
        label="Possui CAR:"
        :obrigatorio="true"
        v-model="imovel.possuiCar"
        :nomeAba="nomeAba" :widthColumn="24"
        :nameValidation="nomeAba + '/Possui CAR'"
        @input="handleNumCar"
      />
    </el-row>
    <div v-if="imovel.possuiCar">
      <Alert
        type="info"
        title=""
        description="Informe abaixo o(s) número(s) do(s) CAR, ou inclua a geometria do imóvel
        (por meio de um arquivo shapefile ou desenhando o polígono) para selecionar seu(s) CAR."
        :colapsedMode="true"
      />
    </div>
    <div v-if="imovel.possuiCar === false">
      <Alert
        type="warning"
        title="Atenção!"
        description="Prossiga com o cadastro, porém recomendamos que consulte os órgãos
        ambientais competentes para efetuar o cadastramento do seu imóvel."
        :colapsedMode="true"
        :closable="false"
      />
      <div class="mt-2">
        <Alert
          type="info"
          title=""
          description="Inclua no mapa o arquivo shapefile ou desenhe o polígono do seu imóvel."
          :colapsedMode="true"
          :closable="false"
        />
      </div>
    </div>

    <div>
      <el-row v-if="imovel.possuiCar">
        <el-col :span="12">
          <validation-provider :rules="!imovel.numerosRecibosCar.length ? 'requiredCAR' : ''" v-slot="{ errors }" mode="lazy" :name="nomeAba + '/Número do CAR'">
            <Label label="Número do CAR:" />
            <el-input
              placeholder="UF-0000000-0000.0000.0000.0000.0000.0000.0000.0000"
              class="input"
              v-model="numeroCar"
              name="Número do CAR"
              v-mask="'AA-XXXXXXX-XXXX.XXXX.XXXX.XXXX.XXXX.XXXX.XXXX.XXXX'"
            >
              <template #append>
                <el-button class="style" icon="el-icon-plus" @click="addCarNum(numeroCar)" :disabled="numeroCar.length < 50" />
              </template>
            </el-input>
            <span class="help erro"> {{ errors[0] }}</span>
          </validation-provider>
          <div class="tag-app-input marginTop">
            <el-tag
              v-for="(numCar, index) in imovel.numerosRecibosCar"
              :key="index"
              closable
              type="info"
              size="medium"
              @close="removeCarNum(numCar.numero)"
            >
              {{ numCar.numero }}
            </el-tag>
          </div>
        </el-col>
      </el-row>
      <div :class="imovel.possuiCar === false ? 'mt-2': ''">
        <RegistrationMap
          ref="registrationMap"
          class="mt-1"
          :validation="!imovel.geoJson.length ? 'required': ''"
          :showInfoMessage="imovel.possuiCar"
          validationName="Imóvel/Georreferenciamento"
          @carInfo="handleCarInfo"
          @setLayers="setLayers"
        />
      </div>
    </div>

    <Endereco
      :endereco="cadastro.imovel.endereco"
      :nomeAba="nomeAba" titulo="Endereço do imóvel:"
      :exibirSwitchMesmoEndereco="true"
      :enderecoCopiado="enderecoCopiado"
      :tipoCadastro="tipoCadastro"
      :camposObrigatorios="['CEP', 'UF', 'MUNICIPIO']"
      :exibirBairroComplemento="false"
    />
    <el-row :gutter="20">
      <el-col :span="11">
        <validation-provider rules="required" v-slot="{ errors }" :name="nomeAba + '/Comunidade ou localidade'">
          <Label label="Comunidade ou localidade:" :obrigatorio="true" />
          <el-input
            class="input"
            name="comunidadeLocalidade"
            v-model="imovel.endereco.comunidadeLocalidade"
            :class="{ erro: errors.length }"
            clearable
            placeholder="Digite a comunidade ou localidade..."
          />
          <span class="help erro">{{ errors[0] }}</span>
        </validation-provider>
      </el-col>
      <el-col :span="11">
        <Label label="Referência de acesso" />
        <el-input
          class="input"
          name="referencia"
          v-model="imovel.endereco.referencia"
          clearable
          placeholder="Digite a referência de acesso..."
        />
      </el-col>
    </el-row>

    <TitleWithRow title="Registro do imóvel" />
    <Alert
      type="info"
      title="Aviso"
      description='Ao responder as perguntas a seguir, você declara estar fazendo isso de forma voluntária, ciente de que as informações
        fornecidas serão utilizadas exclusivamente para fins de análise no âmbito do Programa ABC+ Pará. Caso não queira responder,
        selecione a opção "Não desejo especificar."'
      :colapsedMode="true"
      :closable="false"
    />

    <div class="mt-2">
      <el-row>
        <InputSelect
          label="Situação do imóvel"
          :obrigatorio="true"
          rulesInput="required"
          :nomeAba="nomeAba"
          v-model="imovel.registroImovel.situacao"
          :opcoes="situacaoImovel"
          :widthColumn="12"
          @input="handleSituacaoImovel"
        />
      </el-row>

      <!-- Proprietário  -->
      <el-row v-if="Boolean(imovel.registroImovel.situacao === 'PROPRIETARIO')">
        <el-col :span="12">
          <validation-provider rules="required" v-slot="{ errors }" mode="lazy" :name="nomeAba + '/Número da matrícula'">
            <Label label="Número da matrícula:" :obrigatorio="true" />
            <el-input
              name="Número da matrícula:"
              v-model="imovel.registroImovel.proprietarioImovel.numeroMatricula"
              :class="{'input erro' : errors.length}"
            />
            <span class="help erro" v-if="errors.length > 0"> {{ errors[0] }}</span>
          </validation-provider>
        </el-col>
      </el-row>

      <!-- Posseiro  -->
      <el-row v-if="Boolean(imovel.registroImovel.situacao === 'POSSEIRO')">
        <InputSelect
          label="Tipo de posse:"
          :obrigatorio="true"
          rulesInput="required"
          v-model="imovel.registroImovel.posseiro.tipoPosse"
          :opcoes="tipoPosse"
          :widthColumn="12"
        />
        <el-col :span="11" class="ml-forms" v-if="Boolean(imovel.registroImovel.posseiro.tipoPosse === 'OUTROS')">
          <validation-provider rules="required" v-slot="{ errors }" mode="lazy" :name="nomeAba + '/Especificar tipo de posse'">
            <Label label="Especificar:" :obrigatorio="true" />
            <el-input
              name="Especificar:"
              v-model="imovel.registroImovel.posseiro.detalhePosse"
              :class="{'input erro' : errors.length}"
            />
            <span class="help erro" v-if="errors.length > 0"> {{ errors[0] }}</span>
          </validation-provider>
        </el-col>
      </el-row>

      <!-- Assentado da Reforma Agrária -->
      <div v-if="Boolean(imovel.registroImovel.situacao === 'ASSENTADO_REFORMA_AGRARIA')">
        <el-row>
          <el-col :span="9">
            <validation-provider rules="required" v-slot="{ errors }" mode="lazy"
              :name="nomeAba + '/Qual é o nome do projeto de assentamento?'"
            >
              <Label label="Qual é o nome do projeto de assentamento?" :obrigatorio="true" />
              <el-input
                name="Qual é o nome do projeto de assentamento?"
                v-model="imovel.registroImovel.assentamentoReforma.nomeProjeto"
                :class="{'input erro' : errors.length}"
              />
              <span class="help erro" v-if="errors.length > 0"> {{ errors[0] }}</span>
            </validation-provider>
          </el-col>
          <InputSelect
            label="Selecione o documento comprobatório do assentamento de reforma agrária"
            v-model="imovel.registroImovel.assentamentoReforma.documento"
            :opcoes="documentoReformaAgraria"
            obrigatorio
            rulesInput="required"
            :nameValidation="nomeAba + '/Documento comprobatório do assentamento de reforma agrária'"
            :widthColumn="13"
            marginLeft
          />
        </el-row>
        <el-row>
          <el-col :span="9">
            <validation-provider rules="required" v-slot="{ errors }" mode="lazy"
              :name="nomeAba + '/Número do documento'"
            >
              <Label label="Número do documento" :obrigatorio="true" />
              <el-input
                name="Número do documento"
                v-model="imovel.registroImovel.assentamentoReforma.especificacaoDocumento"
                :class="{'input erro' : errors.length}"
              />
              <span class="help erro" v-if="errors.length > 0"> {{ errors[0] }}</span>
            </validation-provider>
          </el-col>
          <el-col :span="11" class="ml-forms" v-if="imovel.registroImovel.assentamentoReforma.documento === 'OUTRO'">
            <validation-provider rules="required" v-slot="{ errors }" mode="lazy"
              :name="nomeAba + '/Outro documento comprobatório do assentamento de reforma agrária'"
            >
              <Label label="Especificar:" :obrigatorio="true" />
              <el-input
                name="Especificar:"
                v-model="imovel.registroImovel.assentamentoReforma.outrosDocumentos"
                :class="{'input erro' : errors.length}"
              />
              <span class="help erro" v-if="errors.length > 0"> {{ errors[0] }}</span>
            </validation-provider>
          </el-col>
        </el-row>
      </div>

      <!-- Quilombola -->
      <div v-if="Boolean(imovel.registroImovel.situacao === 'QUILOMBOLA')">
        <el-row>
          <el-col :span="9">
            <validation-provider rules="required" v-slot="{ errors }" mode="lazy" :name="nomeAba + '/Qual é o nome do quilombo'">
              <Label label="Qual é o nome do quilombo?" :obrigatorio="true" />
              <el-input
                name="Qual é o nome do quilombo?"
                v-model="imovel.registroImovel.quilombola.nomeQuilombo"
                :class="{'input erro' : errors.length}"
              />
              <span class="help erro" v-if="errors.length > 0"> {{ errors[0] }}</span>
            </validation-provider>
          </el-col>
          <InputSelect
            label="Selecione abaixo o documento informado:"
            :obrigatorio="true"
            rulesInput="required"
            v-model="imovel.registroImovel.quilombola.documento"
            :opcoes="documentoQuilombo"
            :widthColumn="13"
            marginLeft
          />
        </el-row>
        <el-row>
          <el-col :span="12" v-if="Boolean(imovel.registroImovel.situacao === 'QUILOMBOLA')">
            <validation-provider rules="required" v-slot="{ errors }" mode="lazy"
              :name="nomeAba + '/Número do documento'"
            >
              <Label label="Número do documento" :obrigatorio="true" />
              <el-input
                name="Número do documento"
                v-model="imovel.registroImovel.quilombola.especificacaoDocumento"
                :class="{'input erro' : errors.length}"
              />
              <span class="help erro" v-if="errors.length > 0"> {{ errors[0] }}</span>
            </validation-provider>
          </el-col>
          <el-col :span="11" class="ml-forms" v-if="Boolean(imovel.registroImovel.quilombola.documento === 'OUTRO')">
            <validation-provider
              :rules="imovel.registroImovel.quilombola.documento === 'OUTRO' ? 'required' : ''" v-slot="{ errors }"
              mode="lazy" :name="nomeAba + '/Especificar'"
            >
              <Label label="Especificar" :obrigatorio="imovel.registroImovel.quilombola.documento === 'OUTRO'" />
              <el-input
                name="Especificar"
                v-model="imovel.registroImovel.quilombola.outrosDocumentos"
                :class="{'input erro' : errors.length}"
              />
              <span class="help erro" v-if="errors.length > 0"> {{ errors[0] }}</span>
            </validation-provider>
          </el-col>
        </el-row>
      </div>

       <!-- Indígena -->
      <el-row v-if="Boolean(imovel.registroImovel.situacao === 'INDIGENA')">
        <el-col :span="6">
          <validation-provider rules="required" v-slot="{ errors }" mode="lazy" :name="nomeAba + '/Qual é a terra indígena?'">
            <Label label="Qual é a terra indígena?" :obrigatorio="true" />
            <el-input
              name="Qual é a terra indígena?"
              v-model="imovel.registroImovel.indigena.terra"
              :class="{'input erro' : errors.length}"
            />
            <span class="help erro" v-if="errors.length > 0"> {{ errors[0] }}</span>
          </validation-provider>
        </el-col>

        <el-col :span="5" class="ml-forms">
          <validation-provider rules="required" v-slot="{ errors }" mode="lazy" :name="nomeAba + '/Qual aldeia?'">
            <Label label="Qual aldeia?" :obrigatorio="true" />
            <el-input
              name="Qual aldeia?"
              v-model="imovel.registroImovel.indigena.aldeia"
              :class="{'input erro' : errors.length}"
            />
            <span class="help erro" v-if="errors.length > 0"> {{ errors[0] }}</span>
          </validation-provider>
        </el-col>

        <el-col :span="10" class="ml-forms">
          <validation-provider rules="required" v-slot="{ errors }" mode="lazy" :name="nomeAba + '/Qual povo pertence?'">
            <Label label="Qual povo pertence?" :obrigatorio="true" />
            <el-input
              name="Qual povo pertence?"
              v-model="imovel.registroImovel.indigena.povo"
              :class="{'input erro' : errors.length}"
            />
            <span class="help erro" v-if="errors.length > 0"> {{ errors[0] }}</span>
          </validation-provider>
        </el-col>
      </el-row>

      <!-- Outros  -->
      <el-row v-if="Boolean(imovel.registroImovel.situacao === 'OUTROS')">
        <el-col :span="12">
          <validation-provider rules="required" v-slot="{ errors }" mode="lazy" :name="nomeAba + '/Especifique'">
            <Label label="Especifique" :obrigatorio="true" />
            <el-input
              name="Especifique"
              v-model="imovel.registroImovel.especificacaoOutros"
              :class="{'input erro' : errors.length}"
            />
            <span class="help erro" v-if="errors.length > 0"> {{ errors[0] }}</span>
          </validation-provider>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/scss/_colors.scss';
@import '@/scss/_mixins.scss';
@import '@/scss/_typography.scss';
@import '@/scss/_utilities.scss';

.erro {
  font-size: small;
  color: $color-error;
  margin-top: 5px;
  display: block;
  white-space: pre;
}
</style>



// WEBPACK FOOTER //
// src/App/(authenticated)/modulos/cadastro/formulario-cadastro/imovel/imovel.vue